import Marquee from 'react-fast-marquee';
import styles from './AwardsMarquee.module.css';

function AwardsMarquee({ title, items }) {

    return (

        <div className={styles.awardsMarquee}>
            <h2 className={styles.title}>{title}</h2>
            <Marquee loop={0}>
                {items.map((item, index) => (
                    <span key={index}>
                        <div className={styles.card}>
                            <div className={styles.media_wrap}>
                                <img src={`https:${item.fields.image.fields.file.url}`} alt={item.fields.title} />
                            </div>
                            <p>{item.fields.title}</p>
                            <p>{item.fields.nominations}</p>
                            <p>{item.fields.awards}</p>
                        </div>

                    </span>
                ))}
            </Marquee >

        </div>
    )
}

export default AwardsMarquee;
